import React from "react";
import TravellerForm from "../TravellerForm";

let TravellerFormList = ({
  travellerFormInfoArr,
  handleDateOfBirthChange,
  showHeader
}) => {
  var renderTravellerForms = travellerFormInfoArr.map(formInfo => (
    <TravellerForm
      key={formInfo.id}
      formInfo={formInfo}
      handleDateOfBirthChange={handleDateOfBirthChange}
      showHeader={showHeader}
    />
  ));

  return <div>{renderTravellerForms}</div>;
};

export default TravellerFormList;



// WEBPACK FOOTER //
// ./src/scenes/ReviewOrder/CustomerInfoForm/components/TravellerFormList/index.js